import { getRouteApi } from '@tanstack/react-router';

const dashboardRouteApi = getRouteApi('/_authed/dashboard');

export function useDashboardRouteSearch() {
  return dashboardRouteApi.useSearch();
}
